import { render, staticRenderFns } from "./RowsDragItems.vue?vue&type=template&id=0f59aa7c"
import script from "./RowsDragItems.vue?vue&type=script&lang=js"
export * from "./RowsDragItems.vue?vue&type=script&lang=js"
import style0 from "./RowsDragItems.vue?vue&type=style&index=0&id=0f59aa7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports